import Api from "@/api/index";
import store from "@/store";
import confirmations from "./confirmations";
import alerts from "@/alerts/alert";
import AuthenticationService from "@/services/AuthenticationService";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const gallery_web = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    detail: {},
    queryParam: {},
    modalCreate: false,
    modalEdit: false,
    loading: false,
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
    SET_DETAIL(state, datas) {
      state.detail = datas;
    },
    SET_MODAL_CREATE(state, data) {
      state.modalCreate = data;
    },
    SET_MODAL_EDIT(state, data) {
      state.modalEdit = data;
    },
  },
  actions: {
    async all({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet("gallery-web").then(({ data }) => {
        commit("SET_ALL", data);
        commit("SET_LOADING", false);
      });
    },
    async paginate({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doPaginate("gallery-web/page", payload).then(
        ({ data }) => {
          commit("SET_DATAS", data);
          commit("SET_LOADING", false);
        }
      );
    },
    async show({ commit }, payload) {
      commit("SET_LOADING", true);
      return await Api.doGet(`gallery-web/${payload}`).then(({ data }) => {
        commit("SET_DETAIL", data);
        commit("SET_MODAL_EDIT", true);
        commit("SET_LOADING", false);
      });
    },
    onAction({ commit }, payload) {
      if (payload[1] === "Create") {
        commit("SET_DETAIL", {});
        commit("SET_MODAL_CREATE", true);
      } else if (payload[1] === "Detail") {
        commit("SET_DETAIL", payload[0]);
        commit("SET_MODAL_DETAIL", true);
      } else if (payload[1] === "delete") {
        store.dispatch("gallery_web/confirmation", payload);
      } else if (payload[1] === "Update") {
        store.dispatch("gallery_web/show", payload[0].gallery_web_id);
      }
    },
    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `gallery_web/${payload[1]}`);
    },
    async create({ commit, state }, payload) {
      commit("SET_LOADING", true);
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.post("gallery-web", payload)
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          commit("SET_LOADING", false);
          commit("SET_MODAL_CREATE", false);
          store.dispatch("loading/setLoading", false);
          store.dispatch("gallery_web/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async update({ commit }, payload) {
      commit("SET_LOADING", true);
      return await AuthenticationService.put(
        "gallery-web/" + payload.gallery_web_id,
        payload
      )
        .then(({ data }) => {
          commit("SET_LOADING", false);
          commit("SET_MODAL_EDIT", false);
          alerts.sweetalertToast("success", data.message);
          store.dispatch("gallery_web/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    async delete({ commit }, payload) {
      commit("SET_LOADING", true);
      return await AuthenticationService.delete(
        "gallery-web/" + payload.gallery_web_id,
        payload
      )
        .then(({ data }) => {
          commit("SET_LOADING", false);
          alerts.sweetalertToast("success", data.message);
          store.dispatch("gallery_web/onRefresh");
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
    onRefresh({ state }) {
      store.dispatch("gallery_web/paginate", state.queryParam);
    },
  },
};

export default gallery_web;
